import * as t from 'io-ts';
import { optional } from '../../../server/lib/codec';

export type TPanel = 'prompt' | 'form' | 'success' | 'info' | 'exception';

export interface ITimesList {
  active: boolean;
  buttonText: string;
  value: string;
  anteMeridiem: boolean;
}

export const getScheduledAppointmentDtoV = t.strict({
  date: t.union([t.string, t.null]),
  time: optional(t.string),
});

export const getAppointmentTimesDtoV = t.array(
  t.strict({
    date: t.string,
    times: t.array(t.string),
  }),
);

export type getAppointmentTimesDto = t.TypeOf<typeof getAppointmentTimesDtoV>;
